const actions = {
  async getPackagingSlipConfiguration() {
    return await this.$fulfillmentCustomizationService.getPackagingSlipConfiguration() 
  },
  async updatePackagingSlipConfiguration(_, payload) {
    return await this.$fulfillmentCustomizationService.updatePackagingSlipConfiguration(payload)
  },
  async downloadPackagingSlipPreview(args, payload) {
    return await this.$packingSlipService.downloadPackagingSlipPreview(payload)
  },
  async getPackagingSlipLogo() {
    return await this.$fulfillmentCustomizationService.getPackagingSlipLogo()
  },
  async updatePackagingSlipLogo(_, payload) {
    return await this.$fulfillmentCustomizationService.updatePackagingSlipLogo(payload)
  },
  async deletePackagingSlipLogo() {
    return await this.$fulfillmentCustomizationService.deletePackagingSlipLogo()
  },
  async getPackagingSlipSettings() {
    return await this.$fulfillmentCustomizationService.getPackagingSlipSettings()
  },
  async updatePackagingSlipSettings(_, payload) {
    return await this.$fulfillmentCustomizationService.updatePackagingSlipSettings(payload)
  },
  async getCustomizationPermission() {
    return await this.$fulfillmentCustomizationService.getCustomizationPermission()
  },
}

export default actions;